export function formatCurrency(value, currency = 'USD') {
  const n = Number(value || 0);
  try {
    return new Intl.NumberFormat(undefined, { style: 'currency', currency }).format(n);
  } catch {
    return `$${n.toFixed(2)}`;
  }
}

export function round2(n) {
  return Math.round(Number(n || 0) * 100) / 100;
}

